function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M438.56,512H19.787c-8.214,0-14.876-6.661-14.876-14.876V256.915c0-8.214,6.661-14.876,14.876-14.876 s14.876,6.661,14.876,14.876v225.333h389.021v-32.833c0-8.214,6.661-14.876,14.876-14.876c8.214,0,14.876,6.661,14.876,14.876 v47.709C453.436,505.339,446.774,512,438.56,512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CEE8FA"
    },
    points: "19.787,177.122 19.787,172.332 175.583,14.876 175.583,177.122  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.156,
    y: 219.435,
    style: {
      fill: "#CEE8FA"
    },
    width: 296.061,
    height: 163.65
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M492.217,204.559h-38.782V14.876C453.436,6.661,446.774,0,438.56,0H175.583 c-0.184,0-0.366,0.021-0.55,0.028c-0.164,0.006-0.326,0.013-0.488,0.024c-0.647,0.046-1.288,0.119-1.918,0.247 c-0.006,0-0.01,0.003-0.015,0.003c-0.628,0.128-1.239,0.309-1.842,0.516c-0.152,0.052-0.302,0.106-0.451,0.164 c-0.591,0.223-1.172,0.473-1.73,0.771c-0.015,0.007-0.03,0.013-0.045,0.021c-0.57,0.306-1.113,0.663-1.641,1.043 c-0.134,0.097-0.263,0.195-0.394,0.295c-0.522,0.403-1.029,0.829-1.499,1.303L9.212,161.87c-0.35,0.353-0.678,0.721-0.988,1.104 c-0.202,0.25-0.381,0.512-0.565,0.771c-0.097,0.135-0.202,0.265-0.293,0.403c-0.211,0.32-0.399,0.65-0.583,0.982 c-0.049,0.088-0.106,0.173-0.153,0.262c-0.18,0.341-0.338,0.692-0.489,1.043c-0.039,0.091-0.086,0.177-0.123,0.269 c-0.137,0.336-0.251,0.678-0.363,1.02c-0.039,0.118-0.085,0.231-0.12,0.35c-0.094,0.315-0.165,0.634-0.238,0.954 c-0.036,0.155-0.079,0.305-0.11,0.46c-0.057,0.293-0.092,0.588-0.131,0.882c-0.025,0.186-0.06,0.369-0.077,0.556 c-0.027,0.287-0.031,0.574-0.043,0.861c-0.007,0.183-0.027,0.363-0.027,0.546v4.792c0,8.214,6.661,14.876,14.876,14.876h155.796 c8.214,0,14.876-6.661,14.876-14.876V29.752h233.229v174.807H196.156c-8.215,0-14.876,6.661-14.876,14.876v163.644 c0,8.214,6.661,14.876,14.876,14.876h296.061c8.215,0,14.876-6.661,14.876-14.876V219.435 C507.093,211.219,500.432,204.559,492.217,204.559z M160.707,162.246H50.692L160.707,51.06V162.246z M477.341,368.203H211.032 V234.311h266.309V368.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M263.843,307.569H243.12v28.223c0,3.332-4.061,4.998-8.122,4.998c-4.061,0-8.124-1.666-8.124-4.998 v-66.234c0-3.438,4.061-4.894,8.124-4.894c4.06,0,8.122,1.456,8.122,4.894v25.514h20.725v-25.514c0-3.438,4.061-4.894,8.124-4.894 c4.06,0,8.122,1.456,8.122,4.894v66.234c0,3.332-4.061,4.998-8.122,4.998c-4.061,0-8.124-1.666-8.124-4.998v-28.223H263.843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M336.423,264.662c3.436,0,4.894,3.749,4.894,7.185c0,3.957-1.77,7.395-4.894,7.395h-14.372v56.549 c0,3.332-4.061,4.998-8.124,4.998s-8.124-1.666-8.124-4.998v-56.549h-14.37c-3.125,0-4.896-3.438-4.896-7.395 c0-3.438,1.458-7.185,4.896-7.185H336.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M384.426,313.817c-1.354,2.291-3.438,3.02-5.416,3.02c-1.874,0-3.853-0.625-5.104-3.02l-9.892-18.12 v40.094c0,3.332-4.061,4.998-8.122,4.998s-8.124-1.666-8.124-4.998v-63.006c0-5.936,4.061-8.122,8.124-8.122 c5.831,0,8.332,0.625,12.601,8.122l10.727,18.747l10.726-18.747c4.271-7.497,6.77-8.122,12.603-8.122 c4.165,0,8.122,2.187,8.122,8.122v63.006c0,3.332-4.061,4.998-8.122,4.998c-4.061,0-8.124-1.666-8.124-4.998v-39.054 L384.426,313.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M428.99,340.79c-3.54,0-7.082-1.666-7.082-4.998v-66.234c0-3.438,4.061-4.894,8.124-4.894 s8.124,1.456,8.124,4.894v57.07h23.743c3.125,0,4.686,3.54,4.686,7.082c0,3.54-1.562,7.081-4.686,7.081H428.99V340.79z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailTemplate);
export default __webpack_public_path__ + "static/media/emailTemplate.1af925b5aba7cc442c93b545b3fe36a4.svg";
export { ForwardRef as ReactComponent };